import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LanguageSwitcher } from "@/components/common/LanguageSwitcher";
import { useTranslation } from "@/hooks/useTranslation";

export interface LoginHeaderAction {
  label: string;
  onClick: () => void;
}

interface LoginHeaderProps {
  currentLocale: string;
  /** Default action: the sign-up button of the login page. */
  onGoToRegister?: () => void;
  /** Replaces the sign-up button; the register, forgot-password and email-verification pages pass their sign-in action (JUB-202). */
  action?: LoginHeaderAction;
}

export function LoginHeader({ currentLocale, onGoToRegister, action }: LoginHeaderProps) {
  const { t } = useTranslation();

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center space-x-2">
            <Link to={`/${currentLocale}`} className="flex items-center flex-shrink-0 overflow-visible">
              <span 
                className="font-bold font-logo bg-gradient-to-r from-pink-500 to-rose-500 bg-clip-text text-transparent whitespace-nowrap overflow-visible" 
                style={{ fontSize: '36px', lineHeight: '40px', display: 'inline-block', paddingLeft: '5px', paddingRight: '0' }}
              >
                {t('header.logo')}
              </span>
            </Link>
          </div>
          <div className="flex items-center space-x-4">
            <LanguageSwitcher compact />
            <Button onClick={action ? action.onClick : onGoToRegister} variant="outline">
              {action ? action.label : t('auth.signUp')}
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}

